import { environment } from '@environments/environment';

export const telecomBannerUri = environment.telecomBannerFlash ? environment.telecomBannerFlashUri : environment.telecomBannerUri;
export const telecomBannerTooltipResource = environment.telecomBannerFlash
    ? 'TELECOM.QUALIFICATION.PROVIDER.DISCLAIMER_FLASH'
    : 'TELECOM.QUALIFICATION.PROVIDER.DISCLAIMER';
